import React from 'react';
import { Navigate } from 'react-router-dom';
import GlobalMasterSpareParts from '../components/GlobalMasterSpareParts';

const GlobalMasterSparePartsPage = ({ user }) => {
  if (!['superadmin', 'admin'].includes(user?.role)) {
    return <Navigate to="/services" replace />;
  }

  return <GlobalMasterSpareParts user={user} />;
};

export default GlobalMasterSparePartsPage;
